
import axios from 'axios'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import VueUploadComponent from 'vue-upload-component'
import Selector from "vux/src/components/selector/index";
import XHeader from "vux/src/components/x-header/index";

export default {
name: 'ApplyPage',
components: {XHeader, Selector, Toast, XButton, XDialog, Group, Datetime},
directives: {TransferDom},
comments: {
FileUpload: VueUploadComponent
},
data() {
return {
name: '',
mobile: '',
school: '',
education: '',
graduate: '',
major: '',
stuReason: '',
isborder2: false,
islogo2: true,
border: 'border: 1px dashed black;',
files2: [],
picture2: '',
formData2: {},
f: true,
personalReason: true,
zm: false,
showDialogStyle: false,
shurumarginTop: '90',
phone: false,
picture: false,
pictureBtn2: false,
state: false,
specificReason: '',
graduateTime: '', // 毕业时间
}
},
mounted() {
this.timeSelect();
},
methods: {

getTimeState: function () {

let timeNow = new Date();

let hours = timeNow.getHours();

let state = '';
if (hours >= 0 && hours <= 10) {
state = '同学上午好！'
} else if (hours > 10 && hours <= 14) {
state = '同学中午好！'
} else if (hours > 14 && hours <= 18) {
state = '同学下午好！'
} else if (hours > 18 && hours <= 24) {
state = '同学晚上好！'
}
return state
},

timeSelect: function () {
let date = new Date();
let nowYear = date.getFullYear() + 1;
let year_select = document.getElementById('graduate');
for (let i = nowYear; i > parseInt(nowYear) - 5; i--) {
let optionYear = document.createElement('option');
optionYear.innerHTML = i + '年';
optionYear.value = i + '年';
year_select.appendChild(optionYear)
}
},

handleFileChange2(e) {
let inputDOM = this.$refs.inputer2;
this.file = inputDOM.files[0];
let size = Math.floor(this.file.size / 1024);
this.formData2 = new FormData();
this.formData2.append("file", this.file); 

axios.post('http://student.hmifo.com/admin/application/storage/upload', this.formData2).then((r) => {
console.log(r);
if (r.data.code === 200) {
this.isborder2 = true
this.islogo2 = false
this.picture2 = r.data.data.pictureName
console.log(this.picture2)
this.$vux.toast.text('图片上传成功！')
} else {
this.showDialogStyle = true;
this.picture = true
this.$vux.toast.text('图片上传失败，请重试！')
}
}).catch((error) => {
console.log(error);
this.$vux.toast.text('提交失败!')
})
},

Submit: function () {
this.pictureBtn1 = false;
this.pictureBtn2 = false;
let param = new URLSearchParams();
param.append('name', this.name);
param.append('mobile', this.mobile);
param.append('school', this.school);
param.append('education', this.education);
param.append('graduate', this.graduate);
param.append('major', this.major);
param.append('stuReason', this.stuReason);
param.append('pay', this.picture2);
param.append('specificReason', this.specificReason);
console.log(this.specificReason)
if (this.name.length === 0 || this.name.split('').join('').length === 0) {
this.$vux.toast.text('姓名不许为空!');
return

} else if (this.mobile.length <= 10 || this.mobile === '' || !/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.mobile)) {
this.$vux.toast.text('请填写正确的手机号!');
return
} else if (this.school.length === 0 || this.school.split('').join('').length === 0) {
this.$vux.toast.text('学校不许为空!');
return
} else if (this.education.length === 0 || this.education.split('').length === 0) {
this.$vux.toast.text('学历不许为空!');
return
} else if (this.graduate.length === 0 || this.graduate.split('').length === 0) {
this.$vux.toast.text('毕业时间不许为空!');
return
} else if (this.major.length === 0 || this.major.split('').length === 0) {
this.$vux.toast.text('专业不许为空!');
return
} else if (this.stuReason.length === 0 || this.stuReason.split('').length === 0) {
this.$vux.toast.text('解约理由不许为空!');
return
} else if (this.picture2 === '') {
this.showDialogStyle = true;
this.pictureBtn2 = true;
this.state = true
return
} else if (this.stuReason === '其他个人原因' &&this.specificReason === '') {
this.$vux.toast.text('请填写具体原因！');
return
}



























axios.post('http://student.hmifo.com/admin/application/applyTermOne', param).then((r) => {
if (this.state === false) {
if (r.data.code === 401) {

this.showDialogStyle = true;
this.phone = true;
return false
}
}
if (r.data.code === 500) {
this.$vux.toast.text(r.data.message)
}
if (r.data.code === 200) {
sessionStorage.setItem('mobile', r.data.data.mobile);
sessionStorage.setItem('termId', r.data.data.termId);
this.$router.push({path: '/OnCheck'});
this.$vux.toast.text('提交成功！')
}
}).catch((error) => {
console.log(error);
this.$vux.toast.text('提交失败！')

})
},

changeType: function () {
let select = this.stuReason;
this.zm = true;
if (select === '其他个人原因') {
this.personalReason = true

this.shurumarginTop = 150
} else {
this.personalReason = false
this.shurumarginTop = 150
}
},
log(str1, str2 = '') {
console.log(str1, str2)
},
onConfirm (val) {
console.log('on-confirm arg', val)
console.log('current value', this.value1)
},
change(val) {
console.log(val)
}
}
}



// WEBPACK FOOTER //
// ./src/components/ApplyPage.vue